<div class="row">
    <div class="col-12">
        <ng-template #template let-anchor>
            <span>{{ anchor.nativeElement.innerText }}</span>
        </ng-template>

        <div kendoTooltip showOn="none" filter=".k-grid" [tooltipTemplate]="template" (mouseover)="showTooltip($event)">
            <kendo-grid
                [data]="gridView"
                [pageable]="{ type: 'numeric', info: true, buttonCount: 3, pageSizes: [10, 20, 50] }"
                [pageSize]="pageSize"
                [skip]="skip"
                [sortable]="true"
                [resizable]="true"
                (pageChange)="pageChange($event)">
                <kendo-grid-column title="{{ 'Id' | translate }}" field="id"></kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Action / Status Change Role Id' | translate }}"
                    field="pcsDocumentAndApprovalActionRoleId"></kendo-grid-column>
                <kendo-grid-column title="{{ 'Action Role From Status' | translate }}">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.pcsDocumentAndApprovalFromStatus) {
                            <span>
                                {{
                                    row.pcsDocumentAndApprovalFromStatus.localizedCode +
                                        ' - ' +
                                        row.pcsDocumentAndApprovalFromStatus.name
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Action Role To Status' | translate }}">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.pcsDocumentAndApprovalToStatus) {
                            <span>
                                {{
                                    row.pcsDocumentAndApprovalToStatus.localizedCode +
                                        ' - ' +
                                        row.pcsDocumentAndApprovalToStatus.name
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Created Of Notification' | translate }}">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.createdDate) {
                            <span>
                                {{ row.createdDate | date: 'dd.MM.yyyy HH:mm' }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Resend' | translate }}">
                    <ng-template kendoGridCellTemplate let-row>
                        <button class="btn btn-sm btn-warning">Resend</button>
                    </ng-template>
                </kendo-grid-column>
                <ng-template kendoGridNoRecordsTemplate>
                    <p>{{ 'No records available' | translate }}.</p>
                </ng-template>
            </kendo-grid>
        </div>
    </div>
</div>
